interface InvoiceInfo {
  company: string | null
  line1: string | null
  zip: string | null
  city: string | null
  country: string | null
  vat_number: string | null
  ean_number: string | null
}

const setValue = (id: string, value: string | null) => {
  const field = document.getElementById(id) as HTMLInputElement | null
  if (field) { field.value = value || '' }
}

// Countries outside the rendered options (DK/NO/SE/FI/LT) leave the select blank
const setCountry = (id: string, value: string | null) => {
  const select = document.getElementById(id) as HTMLSelectElement | null
  if (!select) { return }
  const exists = !!value && Array.from(select.options).some((option) => option.value === value)
  select.value = exists ? (value as string) : ''
}

export default function initWarehouseRentListOrder() {
  document.addEventListener('DOMContentLoaded', () => {
    const select = document.getElementById('warehouse_rent_list_location_id') as HTMLSelectElement | null
    const url = select && select.dataset.invoiceInfoUrl
    if (!select || !url) { return }

    // Guards against out-of-order responses: every change (including clearing)
    // bumps the token, and a response is applied only if it is still the latest.
    let requestToken = 0

    select.addEventListener('change', async () => {
      const token = ++requestToken
      if (!select.value) { return } // clearing the select leaves the invoice fields untouched

      try {
        const response = await fetch(`${url}?location_id=${encodeURIComponent(select.value)}`, {
          headers: { Accept: 'application/json' },
        })
        if (!response.ok) { return }
        const data: InvoiceInfo = await response.json()
        if (token !== requestToken) { return } // a newer selection happened meanwhile

        setValue('warehouse_rent_list_invoice_company', data.company)
        setValue('warehouse_rent_list_invoice_address_attributes_line1', data.line1)
        setValue('warehouse_rent_list_invoice_address_attributes_zip', data.zip)
        setValue('warehouse_rent_list_invoice_address_attributes_city', data.city)
        setCountry('warehouse_rent_list_invoice_address_attributes_country', data.country)
        setValue('warehouse_rent_list_invoice_vat_number', data.vat_number)
        setValue('warehouse_rent_list_invoice_ean_number', data.ean_number)
      } catch {
        // network or JSON parse failure: leave the invoice fields untouched
      }
    })
  })
}
